export default __webpack_public_path__ + "static/media/create-c.54f4b51d.png";